interface FeatureShowcase {
	title: string;
	description: string;
	media: {
		type: "image" | "video";
		src: string;
		alt: string;
	};
}

const features: FeatureShowcase[] = [
	{
		title: "Custom RSVP options",
		description:
			"Create custom RSVP options using your own emojis with attendee limits and waitlists.",
		media: {
			type: "video",
			src: "/static/premium1.mp4",
			alt: "Custom RSVP options with emojis",
		},
	},
	{
		title: "Recurring events",
		description:
			"Flexible repeat options - daily, weekly, monthly, yearly, by weekday.",
		media: {
			type: "video",
			src: "/static/premium2.mp4",
			alt: "Creating recurring events",
		},
	},
	{
		title: "Attendee Roles",
		description:
			"Add roles to users who sign up and grant access to private event channels.",
		media: {
			type: "video",
			src: "/static/premium5.mp4",
			alt: "Attendee roles being assigned",
		},
	},
	{
		title: "Two way GCal Sync",
		description:
			"Instantly sync events between Discord and Google Calendar - no more delays!",
		media: {
			type: "video",
			src: "/static/gcal_sync.mp4",
			alt: "Two way Google Calendar sync",
		},
	},
];

export function GifFeatureSections() {
	return (
		<div className="mx-auto max-w-6xl px-4 py-16">
			<h2 className="mb-16 text-center text-4xl font-bold tracking-tight text-white">
				See <span className="sesh-text">sesh</span> premium in action
			</h2>
			<div className="space-y-20">
				{features.map((feature, index) => {
					const isEven = index % 2 === 0;
					return (
						<div
							key={index}
							className={`flex flex-col items-center gap-8 lg:flex-row ${
								isEven ? "lg:flex-row" : "lg:flex-row-reverse"
							}`}
						>
							{/* Media section */}
							<div className="w-full lg:w-1/2">
								<div className="group overflow-hidden rounded-xl border border-slate-700 bg-slate-900/50 transition-all duration-300 hover:border-slate-600">
									{feature.media.type === "video" ? (
										<video
											className="h-64 w-full object-cover transition-transform duration-300 group-hover:scale-105"
											autoPlay
											loop
											muted
											playsInline
										>
											<source
												src={feature.media.src}
												type="video/mp4"
											/>
											{feature.media.alt}
										</video>
									) : (
										<img
											src={feature.media.src}
											alt={feature.media.alt}
											className="h-64 w-full object-cover transition-transform duration-300 group-hover:scale-105"
										/>
									)}
								</div>
							</div>

							{/* Content section */}
							<div className="w-full text-center lg:w-1/2 lg:text-left">
								<h3 className="mb-4 text-3xl font-bold text-white">
									{feature.title}
								</h3>
								<p className="text-lg leading-relaxed text-slate-300">
									{feature.description}
								</p>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
